import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ErrorLogComponent } from './error-log/error-log.component';
import { LoginComponent } from './login/login.component';
import { MainComponent } from './main/main.component';
import { AuthGuard } from './service/auth.guard';
import { SettingComponent } from './setting/setting.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { TransactionComponent } from './transaction/transaction.component';
import { LoginLogComponent } from './login-log/login-log.component';
import { RegisterComponent } from './register/register.component';
import { ClientOfferComponent } from './client-offer/client-offer.component';
import { ClientDirectoryComponent } from './client-directory/client-directory.component';
import { CouponCodeComponent } from './coupon-code/coupon-code.component';
// import { ToggleButtonComponent } from './toggle-button/toggle-button.component';


const routes: Routes = [

  {
    path: '', redirectTo: 'login', pathMatch: 'full',
  },
  {
    path: 'login', component: LoginComponent,
  },
  {
    path: 'register', component: RegisterComponent,
  },
  {
    path: 'transaction', component: TransactionComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'user', component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'dashboard', component: MainComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'setting', component: SettingComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'error-log', component: ErrorLogComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'log-in-log', component: LoginLogComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'maintenance', component: MaintenanceComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'client-directory', component: ClientDirectoryComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'reports',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./reports/reports.module').then(m => m.ReportsModule)
  },
  {
    path: 'client-offer', component: ClientOfferComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'coupon-code', component: CouponCodeComponent,
    canActivate: [AuthGuard],
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
